let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Km4b")).then(() => parcelRequire('KbLzh'));